module.exports = __webpack_public_path__ + "img/poulpe_computer.02dc22c1.png";